import ClosedButton from './ClosedButton';

export default ClosedButton;
